module.exports = __webpack_public_path__ + "img/2.86537021.jpg";